import React, { useState }from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFilters } from 'reducers/filtersNTSlice';
import { resetPagination } from 'reducers/paginationNTsSlice';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages'; 
import NTFilter from "pages/NT/filterNT/NTFilter";

const HomeNT = () => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const dispatch = useDispatch();
    const filtersNts = useSelector((state) => state.filtersNTs); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false); 
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(false); 
    const [showModalContractSettings, setShowModalContractSettings] = useState(false); 
    const [showModalFormSettings, setShowModalFormSettings] = useState(false); 
    const [showModalNTSettings, setShowModalNTSettings] = useState(true); 
    const [showModalShippingsSettings, setShowModalShippingsSettings] = useState(false); 
    const [showModalRegisterBookSettings, setShowModalRegisterBookSettings] = useState(false); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(false); 
    const [showModalTicketsSettings, setShowModalTicketsSettings] = useState(false); 
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(false); 
        
    const scriptUrl = '/js/sb-admin-2.min.js'; 
 
    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ typesdiFromES: "", typesdiToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ typesdiFromEN: "", typesdiToEN: "" }));
        }
    };
    
    const closeModalNT = () => {     
        setIndexShowSettings(0);
        setIndexShowSettings(indexShowSettings);
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalStoreSettings(showModalStoreSettings); 
        setShowModalFormSettings(showModalFormSettings);  
        setShowModalContractSettings(showModalContractSettings);
        setShowModalGeneralSettings(showModalGeneralSettings);
        setShowModalNTSettings(showModalNTSettings); 
        setShowModalShippingsSettings(showModalShippingsSettings);
        setShowModalRegisterBookSettings(showModalRegisterBookSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        setShowModalArticlesSettings(showModalArticlesSettings);
        setShowModalTicketsSettings(showModalTicketsSettings);
        dispatch(resetPagination());
        dispatch(resetFilters());
        return () => {};
    }; 

    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main_NT')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/nt">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersNts.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersNts.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersNts.idFrom}
                    </li>
                    <div className={filtersNts.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_To')}
                    </div>
                    <li className={filtersNts.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.idTo==='' ? t('Text_Filter_Not_Apply'): filtersNts.idTo}
                    </li>
                    
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Forms_Store_Master"))&&
                        <>
                            <div className={filtersNts.defaultStoreIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_From')}
                            </div>
                            <li className={filtersNts.defaultStoreIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersNts.defaultStoreIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersNts.defaultStoreIdFrom}
                            </li>
                            <div className={filtersNts.defaultStoreIdTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_To')}
                            </div>
                            <li className={filtersNts.defaultStoreIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersNts.defaultStoreIdTo==='' ? t('Text_Filter_Not_Apply'): filtersNts.defaultStoreIdTo}
                            </li>
                        </>
                    }
                    {(roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Forms_Store_Master"))
                        || roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Forms_User_Master"))) &&
                        <>
                            <div className={filtersNts.useraccountIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}> 
                                {t('Text_Filter_Useraccount_From')}
                            </div>
                            <li className={filtersNts.useraccountIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersNts.useraccountIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersNts.useraccountIdFrom}
                            </li>
                            <div className={filtersNts.useraccountIdTo===''?"sidebar-heading":"sidebar-heading text-white"}> 
                                {t('Text_Filter_Useraccount_To')}
                            </div>
                            <li className={filtersNts.useraccountIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersNts.useraccountIdTo==='' ? t('Text_Filter_Not_Apply'): filtersNts.useraccountIdTo}
                            </li>
                        </>
                    } 
                    <div className={filtersNts.numberNTFrom===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_NumberNT_From')}
                    </div>
                    <li className={filtersNts.numberNTFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.numberNTFrom==='' ? t('Text_Filter_Not_Apply'): filtersNts.numberNTFrom}
                    </li>
                    <div className={filtersNts.numberNTTo===''?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_NumberNT_To')}
                    </div>
                    <li className={filtersNts.numberNTTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.numberNTTo==='' ? t('Text_Filter_Not_Apply'): filtersNts.numberNTTo}
                    </li>
                    
                    <div className={filtersNts.dateSheetFrom===null?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_DateSheet_From')}
                    </div>
                    <li className={filtersNts.dateSheetFrom===null?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.dateSheetFrom===null ? t('Text_Filter_Not_Apply'): new Date(filtersNts.dateSheetFrom).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>                    
                    <div className={filtersNts.dateSheetTo===null?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_DateSheet_To')}
                    </div>
                    <li className={filtersNts.dateSheetTo===null?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.dateSheetTo===null ? t('Text_Filter_Not_Apply'): new Date(filtersNts.dateSheetTo).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
 
                    <div className={filtersNts.ori_tras_store_idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_OriTras_From')}
                    </div>
                    <li className={filtersNts.ori_tras_store_idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.ori_tras_store_idFrom==='' ? t('Text_Filter_Not_Apply'): filtersNts.ori_tras_store_idFrom}
                    </li>
                    <div className={filtersNts.ori_tras_store_idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_OriTras_To')}
                    </div>
                    <li className={filtersNts.ori_tras_store_idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.ori_tras_store_idTo==='' ? t('Text_Filter_Not_Apply'): filtersNts.ori_tras_store_idTo}
                    </li>

                    <div className={filtersNts.dest_tras_store_idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_DestTras_From')}
                    </div>
                    <li className={filtersNts.dest_tras_store_idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.dest_tras_store_idFrom==='' ? t('Text_Filter_Not_Apply'): filtersNts.dest_tras_store_idFrom}
                    </li>
                    <div className={filtersNts.dest_tras_store_idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_DestTras_To')}
                    </div>
                    <li className={filtersNts.dest_tras_store_idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersNts.dest_tras_store_idTo==='' ? t('Text_Filter_Not_Apply'): filtersNts.dest_tras_store_idTo}
                    </li>

                    

                     

                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/nt" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    <Link className="collapse-item" to="/nt" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalNT} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <NTFilter
                    showModalNTSettings={showModalNTSettings}
                    setShowModalNTSettings={setShowModalNTSettings}
                /> 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeNT;
